<template>
  <div class="footer" id='footer'>
    <div class="foot wrap">
    	<!-- <ul>
    		<li><a href="index.html">关于我们</a></li>
    		<li><a href="index.html">关于我们</a></li>
    		<li><a href="index.html">关于我们</a></li>
    		<li><a href="index.html">关于我们</a></li>
    		<li><a href="index.html">关于我们</a></li>
    	</ul> -->
    	<!-- <p>© 2018 美时美客直播. All right reserved. Designed with by
								<a href="http://www.msmkzb.com" target="_blank">湖南美时美客视讯科技有限公司</a>
								<a href="http://www.miibeian.gov.cn/" target="_blank">湘ICP备16015411号</a>
								电信增值业务许可证 湘B2-20180008</p> -->
    	<!--<p>版权归美时美客公司所有</p>-->
    	<!-- <p>京ICP备10024636号-4京公网安备11010502008915</p> -->
    </div>
  </div>
</template>

<script>
import vue from 'vue'
export default {
  data () {
    return {
      msg: ''
    }
  }
}
</script>
<style scoped>
.footer{
	margin-top: 20px;
	background: #fff;
}
/*.foot{
	border-top: 1px solid #d3d3d3;
}*/
ul{
	text-align: center;margin: 20px auto;
}
li{
	display: inline-block;padding:0 5px;border-left: 1px solid #d3d3d3;
}
li:first-child{
	border:none;
}
p{
	text-align: center;line-height: 30px;
}
a{
	color: #ff5959;
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue